import { render, staticRenderFns } from "./AddDataTypeDialog.vue?vue&type=template&id=4a8d0328"
import script from "./AddDataTypeDialog.vue?vue&type=script&lang=js"
export * from "./AddDataTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports